module.exports = __webpack_public_path__ + "static/media/ford-car.35821242.jpg";